class RelatedProductsSlider {
    constructor() {
        this.buttons = document.querySelectorAll("[data-related-prod-btn]")
        this.viewWindow = document.querySelector("[data-related-products-window]")
        this.slider = document.querySelector("[data-related-products-slider]")
        this.rootDoc = document.querySelector(":root")

        this.startup()
    }

    setVariable(variable, newVariable) {
        this.rootDoc.style.setProperty(variable, newVariable)
    }

    getVariable(variable) {
        return getComputedStyle(this.rootDoc).getPropertyValue(variable)
    }

    startup() {
        this.resizing()
        window.addEventListener("resize", () => this.resizing())
    }

    resizing() {
        this.windowWidth = this.viewWindow.getBoundingClientRect().width
        this.setProductsOnPage()

        this.tileWidth = (this.windowWidth - (32 * this.productsOnPage))/this.productsOnPage
        this.setVariable("--related-products-x", `${this.tileWidth}px`)
    }

    setProductsOnPage() {
        if(this.windowWidth > 1000)
            this.productsOnPage = 3
        else if(this.windowWidth < 1000 && this.windowWidth > 600)
            this.productsOnPage = 2
        else this.productsOnPage = 1

        if(relatedProdCount > this.productsOnPage) {
            this.buttons.forEach(button => {
                if(button.classList.contains("hidden"))
                    button.classList.remove("hidden")
            })
        } else {
            this.buttons.forEach(button => {
                if(!button.classList.contains("hidden")) {
                    button.classList.add("hidden")
                }
            })
        }
    }

}

const related_products = new RelatedProductsSlider()
console.log(related_products)